import type { GetProductsResItem2ProductsItemDto } from '@travelity/api/generated';
import { getMinPriceFromDualCurrency } from '@/utils/getMinPriceFromDualCurrency';

export const getMinPriceWithCurrency = (
    products: GetProductsResItem2ProductsItemDto[]
) => {
    let currency = '';

    const minPrice = products.reduce((sum, product) => {
        return (
            sum +
            product.items.reduce((itemSum, { pricing }) => {
                const prices =
                    pricing?.items
                        ?.map(priceItem => {
                            currency = priceItem.currency.abbr;
                            return getMinPriceFromDualCurrency(
                                priceItem.price.original
                            );
                        })
                        .filter((value): value is number =>
                            Number.isFinite(value)
                        ) ?? [];

                if (!prices.length) return itemSum;

                return itemSum + Math.min(...prices);
            }, 0)
        );
    }, 0);

    return {
        minPrice,
        currency,
    };
};
